import { useQuery } from '@tanstack/react-query'
import Locations from 'src/client/resources/LocationsLegacy'
import logger from 'src/utils/logger'

const usePublicInformation = ({ locationId }: { locationId: number }) => {
  return useQuery({
    queryKey: [
      'public-information',
      {
        locationId,
      },
    ] as const,
    queryFn: async ({ queryKey: [, { locationId: lid }] }) =>
      Locations.getPublicInformation(lid),
    onError: (error) => {
      logger.error('WAF usePublicInformation - error', { error })
    },
    refetchOnWindowFocus: false,
    enabled: !!locationId && !isNaN(locationId),
  })
}

export default usePublicInformation
